import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, Slide } from 'react-toastify';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import BatchOrderSearchHotkey from '../../hotkeys/scan-to-batch-order-search';
import ScanImage from './scan.jpg';

import style from './scan-to-batch-modal.module.less';

const ScanToBatchModal = ({ modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <>
      <BatchOrderSearchHotkey>
        <Modal className={style['scan-to-batch-modal']}>
          <ModalHeader closeModal={closeModal}>
            <FormattedMessage defaultMessage='Barcode Scan Search' description='scanToBatch.batchModalTitle' id='7yVs7i' />
          </ModalHeader>
          <ModalBody className={style['modal-body']}>
            <div className={style['modal-sub-header']}>
              <FormattedMessage defaultMessage='Scan your barcode' description='scanToBatch.subheader' id='Wtp2h3' />
            </div>
            <div>
              <img alt='barcode' src={ScanImage} />
            </div>
            <div className={style.instructions}>
              <FormattedMessage
                defaultMessage='Your scanned barcode(s) will be located and added to the current batch.'
                description='scanToBatch.instructions'
                id='OIw8u0'
              />
            </div>
          </ModalBody>
        </Modal>
      </BatchOrderSearchHotkey>
      <ToastContainer hideProgressBar pauseOnHover position='bottom-right' transition={Slide} />
    </>
  );
};

ScanToBatchModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};

export default ScanToBatchModal;
